import React from "react";
import { Tooltip } from "antd";
import { DIFF_LEGEND_ITEMS } from "./compareConstants";
import "./CompareLegend.css";

const InfoIcon = () => (
  <svg
    className="cl-info-icon"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);

const CompareLegend = () => (
  <div className="cl-root">
    <span className="cl-title">
      Legend – Station movement (by WDQMS category steps)
    </span>
    <div className="cl-items">
      {DIFF_LEGEND_ITEMS.map(item => (
        <div key={item.label} className="cl-item">
          <span className="cl-dot" style={{ background: item.color }} />
          <span className="cl-label">{item.label}</span>
          <Tooltip
            placement="right"
            title={item.tooltip}
            overlayClassName="cl-tooltip"
          >
            <span className="cl-info-trigger">
              <InfoIcon />
            </span>
          </Tooltip>
        </div>
      ))}
    </div>
  </div>
);

export default CompareLegend;
